import { render, staticRenderFns } from "./SArticleCate.vue?vue&type=template&id=3892160a&scoped=true"
import script from "./SArticleCate.vue?vue&type=script&lang=js"
export * from "./SArticleCate.vue?vue&type=script&lang=js"
import style0 from "./SArticleCate.vue?vue&type=style&index=0&id=3892160a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3892160a",
  null
  
)

export default component.exports